<template>
    <div class="gsc-layout-content">
        <div class="gsc-tabs-btn">
            <span :class="{'btn-item': true, 'btn-item-target': gscTabSIndex === 0}" @mouseenter="gscTabsHover(0)">
                {{$t('common.announcement')}}
            </span>
            <span :class="{'btn-item': true, 'btn-item-target': gscTabSIndex === 2}" @mouseenter="gscTabsHover(2)">{{$t('index.common.download')}}</span>
        </div>

        <div v-if="gscTabSIndex === 0" class="gsc-tabs-con gsc-tabs-con1">
            <ul class="list">
                <li v-for="(item, index) in notificationList" :key="index" class="item" @click="goNotificationDetail(item)" >
                    <span class="title" :class='{"is-new": isThreeDays(item.publishTime)}' :style="{ color: item.seeFlag === 'N' ? '#000' : '#999' }">{{item.noticeTitle}}</span>
                    <span class="time">{{item.publishTime.split(" ")[0]}}</span>
                </li>
            </ul>
            <span v-if="gscTabSIndex === 0" class="more" @click="goNotification">{{$t('common.more')}}</span>
        </div>
        <div v-if="gscTabSIndex === 2" class="gsc-tabs-con gsc-tabs-con1">
            <ul class="download-list">
                <li @click="download('17a36a26e9529b2d48884e74f8a850dc', '17a36b6cae615d1035c646e4d08a19d4')">{{$t('index.common.word1')}}</li>
                <li @click="download('17a36a318ff6414feb6d7704277b9c66', '')">{{$t('index.common.word3')}}</li>
                <li @click="download('17a36a38bc78c15c46af7334c9894ce2', '17a36b71248f2c21835d7ec490995ab3')">{{$t('index.common.word2')}}</li>
                <li v-for="item in INT_INDEX_FILES" :key="item.value" @click="downloadFile(item.value)">{{item.label}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { replaceHostName } from '@/utils/index';

export default {
    name: 'Notice',
    data() {
        return {
            gscTabSIndex: 0,
            notificationList: [],
            problemsList: [],
            INT_INDEX_FILES: [],
        };
    },
    methods: {
        gscTabsHover(index) {
            this.gscTabSIndex = index;
        },
        isThreeDays(time) {
            const nowTime = new Date().getTime();
            const timeDiff = nowTime - new Date(time).getTime();
            const threeDays = 3 * 24 * 60 * 60 * 1000;
            return timeDiff < threeDays;
        },
        getNotification() {
            // 通知公告
            axios.get('/srmbase/noticeHeaderGsc/queryNoticeGscHeader', {
                params: {
                    vendorCode: this.vendorCode,
                    page: 1,
                    pageSize: 10,
                },
            }).then((res) => {
                const { data } = res.data.data;
                if (data) {
                    this.notificationList = data.list;
                }
            });
        },
        goNotificationDetail({ noticeHeaderId }) {
            this.$router.push(`/wonderful5/${replaceHostName(location.hostname)}/noticeAnnounce-noticeAnnounceDetail/${noticeHeaderId}`);
        },
        goNotification() {
            this.$router.push(`/wonderful2/${replaceHostName(location.hostname)}/notification-notificationList`);
        },
    },
    mounted() {
        this.getNotification();
        this.getDictByCode('INT_INDEX_FILES');
    },
};
</script>
<style lang="less" scoped>
@import url("../../../../../styles/vars.less");
@default-height: 27px;

.gsc-layout-content {
    padding: 24px;
    .gsc-tabs-btn {
        font-size: 14px;
        border-bottom: 1px solid #DFE3E8;
        position: relative;
        .btn-item {
            display: inline-block;
            padding-bottom: 7px;
            min-width: 56px;
            margin-right: 32px;
            text-align: center;
            cursor: pointer;
        }
        .btn-item-target {
            border-bottom: 2px solid @default-blue;
            color: @default-blue;
        }
        .btn-item-study:hover{
            color: @default-blue;
        }
        .not-view-count {
            position: absolute;
            top: -5px;
            left: 58px;
            width: 20px;
            height: 20px;
            background: @default-red;
            border-radius: 50%;
            text-align: center;
            color: #FFFFFF;
            font-size: 12px;
        }
    }
    .gsc-tabs-con {
        padding: 20px 0px 40px;
        overflow-y: auto;
        height: calc(100% - 40px);
    }
    ::-webkit-scrollbar {
        width: 4px;
        height: 2px;
    }
    .gsc-tabs-con1 {
        .item {
            height: @default-height;
            margin-bottom: 4px;
            font-size: 14px;
            position: relative;
            cursor: pointer;
            &:hover {
                background-color: #E7F2FF;
                .title {
                    color: @default-blue !important
                }
                .time {
                    color: @default-blue !important
                }
            }
            .title {
                line-height: @default-height;
                display: inline-block;
                width: 100%;
                padding-right: 100px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #333333;
            }
            .time {
                line-height: @default-height;
                position: absolute;
                right: 8px;
                top: 0;
                color: #999999;
            }
        }
        .more {
            position: absolute;
            left: 10pxpx;
            bottom: 25px;
            font-size: 14px;
            cursor: pointer;
            color: @default-blue;
        }
    }
    .download-list {
        li {
            font-size: 14px;
            line-height: 40px;
            padding-left:30px;
            background: url('../../../../../assets/icons/icon7.svg') no-repeat 0 center;
            background-size:auto 60%;
            cursor: pointer;
        }
    }
}
</style>
